import { filter, groupBy, keys } from 'lodash';
import React from 'react';
import { Container, CustomDropDown, FooterButton, RangeSlider, RegularText, Row } from 'src/components';
import { metrics } from 'src/themes/Metrics';

import { Divider } from '@mui/material';
import { ScrollView } from 'react-native';
import { useAppDispatch, useAppSelector, useCheckFilterButton } from 'src/common/hooks';
import { amountFormat } from 'src/common/utils/AmountFormat';
import { formatTime } from 'src/common/utils/DateHelper';
import { CustomCheckBox } from 'src/components/bases/CustomCheckbox';
import { Navigation } from 'src/navigations/RootNavigation';
import { busFilterAction, busFilterSelector } from 'src/redux/busfilter/BusFilterSlice';

// const Styled = {
//   RowTouchable: styled(TouchableOpacity).attrs(() => ({
//     activeOpacity: 0.8,
//   }))`
//     flex-direction: row;
//     align-items: center;
//     justify-content: center;
//     height: 40px;
//   `,
// };

// const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

const FilterScreen = () => {
  const dispatch = useAppDispatch();
  const busFilter = useAppSelector(busFilterSelector);

  const [busType, setBusType] = React.useState<string>(busFilter.busType);
  const [chooseClass] = React.useState<number>(busFilter.chooseClass);
  const [hourOfDeparture, setHourOfDeparture] = React.useState<number[]>(busFilter.hourOfDeparture);
  const [hourOfArrival, setHourOfArrival] = React.useState<number[]>(busFilter.hourOfArrival);
  const [priceRank, setPriceRank] = React.useState<number[]>(busFilter.priceRank);
  const [checkboxValues, setCheckboxValues] = React.useState<any[]>([]);

  const isFilterable = useCheckFilterButton({
    busType,
    chooseClass,
    hourOfDeparture,
    hourOfArrival,
    priceRank,
    checkboxValues,
  });

  React.useEffect(() => {
    const temp = [
      { text: 'Nham24 Express', value: 'Nham24 Express', checked: false },
      { text: 'Larryta Express', value: 'Larryta', checked: false },
      { text: 'VET Express', value: 'VET', checked: false },
      // { text: 'Lorem Ipsume', value: 'Lorem Ipsume4', checked: false },
      // { text: 'Lorem Ipsume', value: 'Lorem Ipsume5', checked: false },
      // { text: 'Lorem Ipsume', value: 'Lorem Ipsume6', checked: false },
      // { text: 'Lorem Ipsume', value: 'Lorem Ipsume7', checked: false },
      // { text: 'Lorem Ipsume', value: 'Lorem Ipsume8', checked: false },
    ];
    for (let i = 0; i < temp.length; i += 1) {
      busFilter.chooseBusService.forEach(service => {
        if (temp[i].value === service) {
          temp[i].checked = true;
        }
      });
    }

    setCheckboxValues(temp);
  }, []);

  const handleChangeHourOfDeparture = (event: Event, newValue: number | number[]) => {
    setHourOfDeparture([...(newValue as number[])]);
  };

  const handleChangeHourOfArrival = (event: Event, newValue: number | number[]) => {
    setHourOfArrival([...(newValue as number[])]);
  };

  const handleChangePriceRank = (event: Event, newValue: number | number[]) => {
    setPriceRank([...(newValue as number[])]);
  };
  const handleApplyFilter = () => {
    const result = groupBy(
      filter(checkboxValues, checkbox => checkbox.checked),
      'value',
    );
    const resultKeys = keys(result);

    dispatch(
      busFilterAction({
        busType,
        chooseClass,
        chooseBusService: resultKeys,
        hourOfArrival,
        hourOfDeparture,
        priceRank,
      }),
    );

    Navigation.pop();
  };

  return (
    <Container flex backgroundColor="white">
      <ScrollView contentContainerStyle={{ padding: metrics.huge }} style={{ flex: 1 }}>
        <RegularText fontWeight="500" textLang="chooseClass" />
        {/* <RadioButton index={0} icon="icon-ac" text="AC" isActive={chooseClass === 0} onChange={setChooseClass} />
        <RadioButton
          index={1}
          iconColor={AppColors.red}
          icon="icon-none-ac"
          text="None AC"
          isActive={chooseClass === 1}
          onChange={setChooseClass}
        />
        <RadioButton
          index={2}
          icon="icon-business"
          text="Business"
          isActive={chooseClass === 2}
          onChange={setChooseClass}
        /> */}
        <Divider style={{ marginTop: metrics.medium, marginBottom: metrics.medium }} />
        <CustomDropDown
          label="busType"
          data={[
            { label: 'Bus', value: 'Bus' },
            { label: 'Van', value: 'Van' },
          ]}
          value={busType}
          onChange={setBusType}
        />
        <Divider style={{ marginTop: metrics.medium, marginBottom: metrics.medium }} />
        <RangeSlider
          label="hourOfDeparture"
          min={0}
          max={86399999}
          step={1800000}
          value={hourOfDeparture}
          onChange={handleChangeHourOfDeparture}
          renderBody={(val: number[]) => {
            return (
              <Row width="100%" style={{ justifyContent: 'space-between' }}>
                <RegularText>{formatTime(val[0])}</RegularText>
                <RegularText>{formatTime(val[1])}</RegularText>
              </Row>
            );
          }}
        />
        <Divider style={{ marginTop: metrics.large, marginBottom: metrics.large }} />
        <RangeSlider
          label="hourOfArrival"
          min={0}
          max={86399999}
          step={1800000}
          value={hourOfArrival}
          onChange={handleChangeHourOfArrival}
          renderBody={(val: number[]) => {
            return (
              <Row width="100%" style={{ justifyContent: 'space-between' }}>
                <RegularText>{formatTime(val[0])}</RegularText>
                <RegularText>{formatTime(val[1])}</RegularText>
              </Row>
            );
          }}
        />
        <Divider style={{ marginTop: metrics.large, marginBottom: metrics.large }} />
        <RangeSlider
          label="priceRank"
          min={1}
          max={20}
          step={1}
          value={priceRank}
          onChange={handleChangePriceRank}
          renderBody={(val: number[]) => {
            return (
              <Row width="100%" style={{ justifyContent: 'space-between' }}>
                <RegularText>{amountFormat(val[0])}</RegularText>
                <RegularText>{amountFormat(val[1])}</RegularText>
              </Row>
            );
          }}
        />
        <Divider style={{ marginTop: metrics.large, marginBottom: metrics.large }} />

        <RegularText fontWeight="500" textLang="chooseOperator" />
        <CustomCheckBox onCheck={setCheckboxValues} data={checkboxValues} />
      </ScrollView>
      <FooterButton disabled={!isFilterable} text="applyFilter" onPress={handleApplyFilter} />
    </Container>
  );
};

// interface RadioButtonProps {
//   text: string;
//   isActive: boolean;
//   onChange: (index: number) => void;
//   iconColor?: string;
//   index: number;
//   icon: React.ReactElement;
// }

// const RadioButton: React.FC<RadioButtonProps> = ({ index, icon, onChange, text, isActive }) => {
//   return (
//     <Styled.RowTouchable onPress={() => onChange(index)}>
//       {icon}
//       <Container marginLeft={metrics.medium} flex>
//         <RegularText>{text}</RegularText>
//       </Container>
//       {isActive ? (
//         <Ionicon color={AppColors.primary} name="radio-button-on" size={iconSize.medium} />
//       ) : (
//         <Ionicon name="radio-button-off" size={iconSize.medium} />
//       )}
//     </Styled.RowTouchable>
//   );
// };

export default FilterScreen;
